import React, { cloneElement } from 'react';
import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DynamicPop = dynamic(() => import('./content'), { ssr: false });

const EditGroupNav = props => {
  const { show, hide, visible, loaded } = useLazy();
  const { children } = props;
  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: e => {
            show(e);
          }
        })}
      {loaded && <DynamicPop {...props} visible={visible} onCancel={hide} />}
    </>
  );
};

export default EditGroupNav;
